// expiry.js
const DAY = 24 * 60 * 60 * 1000;

/** Save with TTL (defaults to 1 day) */
export function lsSet(key, value, ttlMs = DAY) {
  try {
    const payload = { v: value, e: Date.now() + ttlMs };
    localStorage.setItem(key, JSON.stringify(payload));
  } catch (err) {
    // Storage may be blocked or full — ignore silently
  }

}

/** Read & auto-delete if expired. Returns null when missing/expired. */
export function lsGet(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const { v, e } = JSON.parse(raw);
    if (typeof e === "number" && Date.now() > e) {
      localStorage.removeItem(key); // auto-clean
      return null;
    }
    return v;
  } catch (err) {
    // Happens if storage is blocked or JSON corrupted
    try {
      localStorage.removeItem(key);
    } catch { }
    return null;
  }
}


/** Optional: remove explicitly */
export function lsDel(key) {
  try {
    localStorage.removeItem(key);
  } catch { }
}

/** Optional: sweep a namespace/prefix */
export function lsSweep(prefix = "") {
  const now = Date.now();
  for (let i = 0; i < localStorage.length; i++) {
    const k = localStorage.key(i);
    if (!k || (prefix && !k.startsWith(prefix))) continue;
    try {
      const { e } = JSON.parse(localStorage.getItem(k) || "{}");
      if (typeof e === "number" && now > e) localStorage.removeItem(k);
    } catch {
      /* ignore */
    }
  }
}
